import CreatePlatformContainer from "@containers/dashboard/platforms/create";
import DashboardLayout from "@layouts/dashboard";

const CreatePlatform = () => {
    return (
        <DashboardLayout title="پلتفرم جدید">
            <CreatePlatformContainer />
        </DashboardLayout>
    );
};

export default CreatePlatform;
